import React from "react";

export default function AsideModal({ show, onClose, AsideContent, children }) {
  if (show) {
    document.body.classList.add("overflowHidden");
  } else {
    document.body.classList.remove("overflowHidden");
  }
  return (
    <div className={`modal${show ? " open" : ""}`}>
      <div className="content-modal">
        <aside className="aside-modal">
          {AsideContent}
        </aside>
        <div className="content-description">
          <div className="flex justify-between md:justify-end pb-8 md:pb-2">
            <div className="icon-container">
              <i className="icon icon-cashv2"></i>
            </div>
            <button onClick={onClose} className="btn-icon btn-primary btn-small">
              <i className="icon icon-close text-[10px]"></i>
            </button>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
